import { useState } from "react"
import { Col, Row } from "react-bootstrap"
import { IoIosCloseCircle } from "react-icons/io"
import { Link } from "react-router-dom"
import FormUsuario from "../../components/usuario/FormUsuario"
import useQuery from "../../hook/useQuery"

function AddUsuario({t}){
    const [edit, setEdit] = useState(true)
    const query = useQuery()
    const id = query.get('id')
    
    return (
        <>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">{`${id ? 'Editar' : 'Agregar'} usuario`}</h2>
                </Col>
                <Col xs="12" md="4" className="text-right">
                    <Link to="/admin/usuarios"><IoIosCloseCircle className="cancel-btn"/></Link>                    
                </Col>
            </Row>
            <FormUsuario id={id} edit={edit} setEdit={setEdit}/>
        </>
    )
}

export default AddUsuario